import { render } from "./AgreementsView.vue?vue&type=template&id=996c4b6c&scoped=true"
import script from "./AgreementsView.vue?vue&type=script&lang=js"
export * from "./AgreementsView.vue?vue&type=script&lang=js"

import "./AgreementsView.vue?vue&type=style&index=0&id=996c4b6c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-996c4b6c"]])

export default __exports__